import { LoadingScreenComponent } from './loader/loading-screen/loading-screen.component';
import { SideNavbarModule } from '../app/sidenavbar.module'
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SmartsearchComponent } from './SearchBox/smartsearch/smartsearch.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {SelectModule} from 'primeng/select';
import {EditorModule} from 'primeng/editor';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { LoadingScreenInterceptor } from './loader/interceptor/loading.interceptor';
import { TalentpoolListComponent } from './talentpool/talentpool-list/talentpool-list.component';
import { CandidateListComponent } from './candidate/candidate-list/candidate-list.component';
import { CreateCandidateComponent } from './candidate/create-candidate/create-candidate.component';
import { CandidateSliderComponent } from './candidate/candidate-slider/candidate-slider.component';
import { CandidateNoteComponent } from './candidate/candidate-note/candidate-note.component';
import { CallLogComponent } from './candidate/call-log/call-log.component';
import { CandidateEmailComponent } from './candidate/candidate-email/candidate-email.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CreateTalentpoolComponent } from './talentpool/create-talentpool/create-talentpool.component';
import { AddToTalentpoolComponent } from './talentpool/add-to-talentpool/add-to-talentpool.component';
// import { MatAutocompleteModule, MatFormFieldModule, MatCheckboxModule, MatInputModule, MatChipsModule, MatIconModule } from '@angular/material';
import { SignupComponent } from './signup/signup.component';
import { OldSettingsComponent } from './old-settings/old-settings.component';
import { EmailTemplateComponent } from './old-settings/email-template/email-template.component';
import { EditEmailTemplateComponent } from './old-settings/edit-email-template/edit-email-template.component';
import { CallLogSettingsComponent } from './old-settings/call-log-settings/call-log-settings.component';
import { EditCallLogSettingsComponent } from './old-settings/edit-call-log-settings/edit-call-log-settings.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { HttpConfigInterceptor } from './_services/httpconfig.interceptor';
import { ErrorDialogComponent } from './errors/error-dialog/error-dialog.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ProfileDetailsComponent } from './user/profile-details/profile-details.component';
import { EditProfileComponent } from './user/edit-profile/edit-profile.component';
import { ChangePasswordComponent } from './user/change-password/change-password.component';
import { SearchtoolboxV2Component } from './SearchBox/searchtoolbox-v2/searchtoolbox-v2.component';
import { IframeSearchtoolboxComponent } from './SearchBox/iframe-searchtoolbox/iframe-searchtoolbox.component';
import { JobDescriptionModalComponent } from './SearchBox/job-description-modal/job-description-modal.component';
import { SubscriptionUsageComponent } from './accounts/subscription-usage/subscription-usage.component';
import { PricingComponent } from './accounts/pricing/pricing.component';
import { MatAutocompleteModule as MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule as MatTooltipModule } from "@angular/material/tooltip";
import {MatProgressBarModule as MatProgressBarModule } from '@angular/material/progress-bar';
import { GoogleLoginService } from './_services/google-login.service';
import { TeaminviteComponent } from './teaminvite/teaminvite.component';
import { EmailIntegrationComponent } from './old-settings/email-integration/email-integration.component';
import { FirstloginComponent } from './firstlogin/firstlogin.component';
import { ExpiryComponent } from "./expirylink/expirylink.component";
import { SearchtoolboxV3Component } from './SearchBox/searchtoolbox-v3/searchtoolbox-v3.component';
import { CompanydirectoryComponent } from './companypages/companydirectory/industrylist/companydirectory.component';
import { CompanyinfoComponent } from './companypages/companyinfo/companyinfo.component';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { CompanylistComponent } from './companypages/companydirectory/companylist/companylist.component';
import { SalarylistComponent } from './companypages/companyinfo/salarylist/salarylist.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { EmailRedirectionComponent } from './old-settings/email-redirection/email-redirection.component';
import { IntroCandidateemailComponent } from './SearchBox/intro-candidateemail/intro-candidateemail.component';
import { CandidateFilterComponent } from './candidate/candidate-filter/candidate-filter.component';
import { PersonSearchComponent } from './person-search/person-search.component';
import { PersonSearchListingComponent } from './person-search-listing/person-search-listing.component';
import {MatRadioModule as MatRadioModule} from '@angular/material/radio';
import { MatChipsModule as MatChipsModule } from "@angular/material/chips";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { CandidateQuickViewComponent } from './candidate-quick-view/candidate-quick-view.component'
import { MatIconModule } from '@angular/material/icon';
import { AdvanceSearchComponent } from './person-search/advance-search/advance-search/advance-search.component';
import { SearchHistoryComponent } from './search-history/search-history.component';
import { DataService } from './data.service';
import { MomentPipe } from './pipe/moment.pipe';
import { PersonSearchCandidateSliderComponent } from './person-search-candidate-slider/person-search-candidate-slider.component';

import { CommonModule, DatePipe } from '@angular/common';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatBadgeModule } from '@angular/material/badge';
import { CuratedTalentPoolsComponent } from './curated-talent-pools/curated-talent-pools.component';
import { JobboardsComponent } from './jobboards/jobboards.component';
import { SearchHighlightsComponent } from './search-highlights/search-highlights/search-highlights.component';
import { PersonSearchContactSliderComponent } from './person-search-contact-slider/person-search-contact-slider.component';
import { TalnepoolCandidateTabsComponent } from './talnepool-candidate-tabs/talnepool-candidate-tabs.component';
import { TalentpoolDetailsComponent } from './talentpool/talentpool-details/talentpool-details.component';
import { SliderNotesTabComponent } from './candidate/candidate-slider/slider-notes-tab/slider-notes-tab.component';
import { TaggedtoTabComponent } from './candidate/candidate-slider/taggedto-tab/taggedto-tab.component';
import { ProfileTabComponent } from './candidate/candidate-slider/profile-tab/profile-tab.component';
import { CandidateTagsComponent } from './candidate/candidate-tags/candidate-tags.component';
import { NewCompnayPageComponent } from './companypages/new-compnay-page/new-compnay-page.component';
import { CompanyListComponent } from './companypages/company-list/company-list.component';
import { SimilarCandidatesComponent } from './person-search/similar-candidates/similar-candidates.component';
import { DocumentPreviewComponent } from './candidate/candidate-slider/document-preview/document-preview.component';
import { CompanyDetailsComponent } from './companypages/company-details/company-details.component';
import { OverviewTabComponent } from './companypages/overview-tab/overview-tab.component';
import { LocationTabComponent } from './companypages/location-tab/location-tab.component';
import { AttrtionTabComponent } from './companypages/attrtion-tab/attrtion-tab.component';
import { EducationTabComponent } from './companypages/education-tab/education-tab.component';
import { SkillsTabComponent } from './companypages/skills-tab/skills-tab.component';
import { TitlesTabComponent } from './companypages/titles-tab/titles-tab.component';
import { TalentmovementTabComponent } from './companypages/talentmovement-tab/talentmovement-tab.component';
import { CompprofileTabComponent } from './companypages/compprofile-tab/compprofile-tab.component';
import { DiversityTabComponent } from './companypages/diversity-tab/diversity-tab.component';

import { CandidateQuickViewContactComponent } from './candidate-quick-view-contact/candidate-quick-view-contact.component';
import { MatSortModule } from '@angular/material/sort';
import { CandidateCardViewComponent } from './candidate-card-view/candidate-card-view.component';
import { PersonalReportsComponent } from './reports/personal-reports/personal-reports.component';
import { TeamMembersReportsComponent } from './reports/team-members-reports/team-members-reports.component';
import { CreateCandidateNewComponent } from './candidate/create-candidate-new/create-candidate-new.component';
import { TalentpoolInsightsComponent } from './talentpool-insights/talentpool-insights.component';
import { ReportDetailsComponent } from './talentpool-insights/report-details/report-details.component';
import { ReportFiltersComponent } from './talentpool-insights/report-filters/report-filters.component';
import { ReportOverviewTabComponent } from './talentpool-insights/report-overview-tab/report-overview-tab.component';
import { ReportLocationTabComponent } from './talentpool-insights/report-location-tab/report-location-tab.component';
import { ReportEducationTabComponent } from './talentpool-insights/report-education-tab/report-education-tab.component';
import { ReportSkillsComponent } from './talentpool-insights/report-skills/report-skills.component';
import { ReportIndustriesComponent } from './talentpool-insights/report-industries/report-industries.component';
import { ReportTitlesComponent } from './talentpool-insights/report-titles/report-titles.component';
import { ReportProfilesComponent } from './talentpool-insights/report-profiles/report-profiles.component';
import { ReportDiversityComponent } from './talentpool-insights/report-diversity/report-diversity.component';
import { ReportsComponent } from './reports/reports.component';
import { ReportCompanyComponent } from './talentpool-insights/report-company/report-company.component';
import { SaveSearchModalComponent } from './save-search-modal/save-search-modal.component';
import { PersonSearchInsightsComponent } from './person-search-insights/person-search-insights.component';
import { CompanyHoverModalComponent } from './company-hover-modal/company-hover-modal.component';
import { ShareTalentpoolsModalComponent } from './share-talentpools-modal/share-talentpools-modal.component';
import { SharedTalentpoolsListingComponent } from './talentpool/shared-talentpools-listing/shared-talentpools-listing.component';
import { SourceHoverModalComponent } from './source-hover-modal/source-hover-modal.component';
import { PersonSearchSimilarSliderComponent } from './person-search-similar-slider/person-search-similar-slider.component';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import {MatSelectModule as MatSelectModule} from '@angular/material/select';
import { PersonSearchFilterComponent } from './person-search-filter/person-search-filter.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CapitalizeFirstLetterPipe } from './pipe/capitalize-first-letter.pipe';
import { EmailCampaignModule } from "./email-campaign/email-campaign.module";
import { PersonSearchModule } from './person-search/person-search.module';
import { BulkRevealModalComponent } from './bulk-reveal-modal/bulk-reveal-modal.component';
import { CompanypageAiComponent } from './companypages/companypage-ai/companypage-ai.component';
import { TalentInsightsAiComponent } from './talentpool-insights/talent-insights-ai/talent-insights-ai.component';
import { PersonSearchAiComponent } from './person-search-ai/person-search-ai.component';
import { OpenaiModule } from "./openai/openai.module";
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { EducationModalComponent } from './education-modal/education-modal.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { AddContactDetailsSliderComponent } from './add-contact-details-slider/add-contact-details-slider.component'; // Import timeseries
import { DocumentTabComponent } from './candidate/candidate-slider/document-tab/document-tab.component';
import { ActivityTabComponent } from './candidate/candidate-slider/activity-tab/activity-tab.component';
import { AddEditExperienceModalComponent } from './add-edit-experience-modal/add-edit-experience-modal.component';
import { ExtendedChiplistComponent } from './extended-chiplist/extended-chiplist.component';
import { SimilarCandidateFilterComponent } from './similar-candidate-filter/similar-candidate-filter.component';
import { ExtendedSliderComponent } from './extended-slider/extended-slider.component';
import { GenAiJdSearchComponent } from './gen-ai-jd-search/gen-ai-jd-search.component';
import { IndianNumberFormatPipe } from './pipe/indian-number-format.pipe';
import { QuickSearchComponent } from './person-search/quick-search/quick-search.component';
import { JdSearchComponent } from './person-search/jd-search/jd-search.component';
import { ContinentSelectorComponent } from './continent-selector/continent-selector.component';
import { AiModalScComponent } from './ai-modal-sc/ai-modal-sc.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { PlatformTourModalComponent } from './platform-tour-modal/platform-tour-modal.component';
import {CarouselModule} from 'primeng/carousel';
import { YouTubePlayerModule } from '@angular/youtube-player';

import { SaveSearchPersmissionModalComponent } from './save-search-persmission-modal/save-search-persmission-modal.component';
import { EuropeAccessModalComponent } from './europe-access-modal/europe-access-modal.component';
import { EuropeAccessDocumentComponent } from './europe-access-document/europe-access-document.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TalentpoolRecommendedCandidateListComponent } from './talentpool-suggested-candidate-list/talentpool-suggested-candidate-list.component';
import { WebbtreeTalentInsightsComponent } from './webtree-website/webbtree-talent-insights/webbtree-talent-insights.component';
import { InsightsProfileSectionComponent } from './webtree-website/insights-profile-section/insights-profile-section.component';
import { WebbtreeInsightsComponent } from './webtree-website/webbtree-insights/webbtree-insights.component';
import { WebbtreeFreemiumBannerComponent } from './webtree-website/webbtree-freemium-banner/webbtree-freemium-banner.component';
import { SevenDayFreeTrialFormComponent } from './webtree-website/seven-day-free-trial-form/seven-day-free-trial-form.component';
import { WebbtreeFreemiumProfileComponent } from './webtree-website/webbtree-freemium-profile/webbtree-freemium-profile.component';
import { TalentpoolReportSectionComponent } from './webtree-website/talentpool-report-section/talentpool-report-section.component';
import { WebbtreeJdSearchFilterModalComponent } from './webtree-website/webbtree-jd-search-filter-modal/webbtree-jd-search-filter-modal.component';
import { GenAiLoaderComponent } from './webtree-website/gen-ai-loader/gen-ai-loader.component';
import { WebbtreeFooterComponent } from './webtree-website/webbtree-footer/webbtree-footer.component';
import { SevenDayFreeTrialModalComponent } from './webtree-website/seven-day-free-trial-modal/seven-day-free-trial-modal.component';

import { UnifiedModule } from './unified/unified.module';
import { NewsignupComponent } from './newsignup/newsignup.component';
import { CompanyInsightsHistoryMdoalComponent } from './company-insights-history-mdoal/company-insights-history-mdoal.component';
import { NewSettingsModule } from './settings/settings.module';
import { SettingsComponent } from './settings/settings.component';
import { PlanComponent } from './settings/plan/plan.component';
import { TagManagementComponent } from './settings/tag-management/tag-management.component';
import { CreditsComponent } from './settings/credits/credits.component';
import { TeamManagementComponent } from './settings/team-management/team-management.component';
import { ProfilesComponent } from './settings/profiles/profiles.component';
import { AtsIntegrationsComponent } from './settings/ats-integrations/ats-integrations.component';
import { EmailTemplatesComponent } from './settings/email-templates/email-templates.component';
import { EmailIntegrationsComponent } from './settings/email-integrations/email-integrations.component';
import { IntegrationComponent } from './unified/integration/integration.component';
import { SelfSignupComponent } from './self-signup/self-signup.component';
import { WebbtreeCompanyListComponent } from './companypages/webbtree-company-list/webbtree-company-list.component';
import { MultiselectSearchComponent } from './companypages/multiselect-search/multiselect-search.component';
import { MatListModule as MatListModule } from '@angular/material/list';
import { WebbtreeCompanyDetailsComponent } from './companypages/webbtree-company-details/webbtree-company-details.component';
import { WebbtreeCompanySearchComponent } from './companypages/webbtree-company-search/webbtree-company-search.component';
import { WebbtreeComapnylistFooterComponent } from './companypages/webbtree-comapnylist-footer/webbtree-comapnylist-footer.component';
import { CompanyComparisonDetailsComponent } from './companypages/company-comparison-details/company-comparison-details.component';
import { CompanyComparisonOverviewComponent } from './companypages/company-comparison-overview/company-comparison-overview.component';
import { AddCompanyModalComponent } from './companypages/add-company-modal/add-company-modal.component';
import { WebbtreeCompanyFiltersComponent } from './companypages/webbtree-company-filters/webbtree-company-filters.component';
import { SimilarCompaniesComponent } from './companypages/similar-companies/similar-companies.component';
import { CompanyComparisonSliderComponent } from './companypages/company-comparison-slider/company-comparison-slider.component';
import { ComparisonSkeletonLoaderComponent } from './companypages/comparison-skeleton-loader/comparison-skeleton-loader.component';
import { CompanylistSkeletonLoaderComponent } from './companypages/companylist-skeleton-loader/companylist-skeleton-loader.component';
import { CompanyComparisonAiComponent } from './companypages/company-comparison-ai/company-comparison-ai.component';
import { ProjectListComponent } from './ai-sourcing/project-list/project-list.component';
import { ProjectDetailsComponent } from './ai-sourcing/project-details/project-details.component';
import { AiSourcingComponent } from './ai-sourcing/ai-sourcing.component';
import { JdDescriptionComponent } from './ai-sourcing/jd-description/jd-description.component';
import { AiSourcingInsightsComponent } from './ai-sourcing/ai-sourcing-insights/ai-sourcing-insights.component';
import { ProjectTalentInsightsComponent } from './projects/project-talent-insights/project-talent-insights.component';
import { AiSourcingProfilesComponent } from './ai-sourcing/ai-sourcing-profiles/ai-sourcing-profiles.component';
import { AiSourcingReviewComponent } from './ai-sourcing/ai-sourcing-review/ai-sourcing-review.component';
import { AiSourcingProfileCardComponent } from './ai-sourcing/ai-sourcing-profile-card/ai-sourcing-profile-card.component';
import { AiSourcingLandingpageComponent } from './ai-sourcing/ai-sourcing-landingpage/ai-sourcing-landingpage.component';
import { ExploringEvaluationCriteriaComponent } from './ai-sourcing/exploring-evaluation-criteria/exploring-evaluation-criteria.component';
import { JdFilterComponent } from './ai-sourcing/jd-filter/jd-filter.component';
import { EvaluationCriteriaComponent } from './ai-sourcing/evaluation-criteria/evaluation-criteria.component';
import { AiSourcingArchiveComponent } from './ai-sourcing/ai-sourcing-archive/ai-sourcing-archive.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InsightsSidebarComponent } from './ai-sourcing/insights-sidebar/insights-sidebar.component';
import { AiSourcingShortlistComponent } from './ai-sourcing/ai-sourcing-shortlist/ai-sourcing-shortlist.component';
import { AiSourcingActivityComponent } from './ai-sourcing/ai-sourcing-activity/ai-sourcing-activity.component';
import { ArchiveCandidateModalComponent } from './ai-sourcing/archive-candidate-modal/archive-candidate-modal.component';
import { AiSourcingProfileSkeletonComponent } from './ai-sourcing/ai-sourcing-profile-skeleton/ai-sourcing-profile-skeleton.component';
import { AiSourcingInsightsAiComponent } from './ai-sourcing/ai-sourcing-insights-ai/ai-sourcing-insights-ai.component';
import { EvaluationSliderComponent } from './ai-sourcing/evaluation-slider/evaluation-slider.component';
import { TalentInsightsFreeTrialFormComponent } from './webtree-website/talent-insights-free-trial-form/talent-insights-free-trial-form.component';
import { TalentInsightsFreeTrialModalComponent } from './webtree-website/talent-insights-free-trial-modal/talent-insights-free-trial-modal.component';
import { TalentInsightsFreeTrialBannerComponent } from './webtree-website/talent-insights-free-trial-banner/talent-insights-free-trial-banner.component';
import { SkillsTaxonomyComponent } from './skills-taxonomy/skills-taxonomy/skills-taxonomy.component';
import { SkilltaxonomyLoaderComponent } from './skills-taxonomy/skilltaxonomy-loader/skilltaxonomy-loader.component';
import { MymodalComponent } from './skills-taxonomy/mymodal/mymodal.component';
import { MarketingModalComponent } from './skills-taxonomy/marketing-modal/marketing-modal.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { BulkEmailCampaignComponent } from './ai-sourcing/bulk-email-campaign/bulk-email-campaign.component';
import { AiResumeScreenerComponent } from './webtree-website/ai-resume-screener/ai-resume-screener.component';
import { AiResumeFormComponent } from './webtree-website/ai-resume-form/ai-resume-form.component';
import { UserprofileComponent } from './webtree-website/userprofile/userprofile.component';
import { SimilarityInsightsModalComponent } from './similarity-insights-modal/similarity-insights-modal.component';
import { JdinsightsModalComponent } from './jdinsights-modal/jdinsights-modal.component';
import { AutopilotPermissionComponent } from './settings/autopilot-permission/autopilot-permission.component';
import { BulkResumeUploadModelComponent } from './import-candidate/bulk-resume-upload-model/bulk-resume-upload-model.component';
import { CsvFileUploadModelComponent } from './import-candidate/csv-file-upload-model/csv-file-upload-model.component';
import { ShareProjectComponent } from './ai-sourcing/share-project/share-project.component';
import { CustomModalComponent } from './ai-sourcing/custom-modal/custom-modal.component';
import { BlurbackdropComponent } from './ai-sourcing/blurbackdrop/blurbackdrop.component';
import { ProjectListSkeletonComponent } from './ai-sourcing/project-list-skeleton/project-list-skeleton.component';
import { NlSearchComponent } from './nl-search/nl-search.component';
import { ResumeScreenComponent } from './resume-screen/resume-screen.component';
import { CandidateListingComponent } from './resume-screen/candidate-listing/candidate-listing.component';
import { CreateJobComponent } from './resume-screen/create-job/create-job.component';
import { ScreeningCriteriaComponent } from './resume-screen/screening-criteria/screening-criteria.component';
import { LandingPageComponent } from './resume-screen/landing-page/landing-page.component';
import { SidebarScreenComponent } from './resume-screen/sidebar-screen/sidebar-screen.component';
import { BulkUploadResumeModelComponent } from './resume-screen/bulk-resume-upload-model/bulk-upload-resume-model.component';
import { JobDetailsComponent } from './resume-screen/job-details/job-details.component';
import { PersonSearchDocumentSliderComponent } from './person-search-document-slider/person-search-document-slider.component';
import { InsightsJoblistComponent } from './insights-joblist/insights-joblist.component';
import { DefaultLocationModalComponent } from './default-location-modal/default-location-modal.component';
import { CampaignsLimitsComponent } from './settings/campaigns-limits/campaigns-limits.component';
import { SharedModule } from './shared/shared.module';
import { AddCandidateAegisModalComponent } from './person-search-listing/add-candidate-aegis-modal/add-candidate-aegis-modal.component';

import * as FusionCharts from "fusioncharts";
import * as world from 'fusioncharts/maps/fusioncharts.world';
import * as maps from 'fusioncharts/fusioncharts.maps';
import * as charts from "fusioncharts/fusioncharts.charts";
import * as FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import * as TimeSeries from 'fusioncharts/fusioncharts.timeseries';
import * as PowerCharts from 'fusioncharts/fusioncharts.powercharts';
import { FusionChartsModule } from 'angular-fusioncharts';
import { DropdownToggleDirective } from './directives/dropdown-toggle.directive';
import Quill from 'quill';
import { CustomInputComponent } from './custom-input/custom-input.component';
import 'quill-mention/autoregister';
import { HireTalentInsightsComponent } from './hire-talent-insights/hire-talent-insights.component';
import { HireSidebarComponent } from './hire-sidebar/hire-sidebar.component';


FusionChartsModule.fcRoot(FusionCharts, charts, maps, world, TimeSeries, PowerCharts, FusionTheme);
FusionCharts.options["license"]({ key: "bj1A1hwA-13F6B1H5C2H2C6D4A4D2C3D4G4I3J-7bbA3D5B3rF2B1H2gjC-13D2E6E1H-9A-7lC11A5C7oqsD4F1H3A3D8E2F6D1D3C4D2tB-21C-16E3A3ME2B-7ziB3D5D1xkB4e1A19A32aarC6D3G4H2D1H1B4A10C1D7B1F5G4H2h==", creditLabel: false });

@NgModule({ declarations: [
        AppComponent,
        SmartsearchComponent,
        LoadingScreenComponent,
        TalentpoolListComponent,
        CandidateListComponent,
        CandidateSliderComponent,
        CandidateNoteComponent,
        CallLogComponent,
        CandidateEmailComponent,
        CreateTalentpoolComponent,
        AddToTalentpoolComponent,
        SignupComponent,
        OldSettingsComponent,
        EmailTemplateComponent,
        EditEmailTemplateComponent,
        CallLogSettingsComponent,
        EditCallLogSettingsComponent,
        ResetpasswordComponent,
        FeedbackComponent,
        ErrorDialogComponent,
        ProfileDetailsComponent,
        EditProfileComponent,
        ChangePasswordComponent,
        SearchtoolboxV2Component,
        IframeSearchtoolboxComponent,
        JobDescriptionModalComponent,
        SubscriptionUsageComponent,
        PricingComponent,
        TeaminviteComponent,
        EmailIntegrationComponent,
        FirstloginComponent,
        ExpiryComponent,
        SearchtoolboxV3Component,
        CompanydirectoryComponent,
        CompanyinfoComponent,
        CompanylistComponent,
        SalarylistComponent,
        EmailRedirectionComponent,
        IntroCandidateemailComponent,
        CandidateFilterComponent,
        PersonSearchComponent,
        PersonSearchListingComponent,
        CandidateQuickViewComponent,
        AdvanceSearchComponent,
        SearchHistoryComponent,
        MomentPipe,
        // PersonSearchCandidateSliderComponent,
        CuratedTalentPoolsComponent,
        JobboardsComponent,
        SearchHighlightsComponent,
        // PersonSearchContactSliderComponent,
        TalnepoolCandidateTabsComponent,
        TalentpoolDetailsComponent,
        SliderNotesTabComponent,
        TaggedtoTabComponent,
        ProfileTabComponent,
        CandidateTagsComponent,
        NewCompnayPageComponent,
        CompanyListComponent,
        SimilarCandidatesComponent,
        DocumentPreviewComponent,
        CompanyDetailsComponent,
        OverviewTabComponent,
        LocationTabComponent,
        AttrtionTabComponent,
        EducationTabComponent,
        SkillsTabComponent,
        TitlesTabComponent,
        TalentmovementTabComponent,
        CompprofileTabComponent,
        DiversityTabComponent,
        CandidateQuickViewContactComponent,
        CandidateCardViewComponent,
        ReportsComponent,
        PersonalReportsComponent,
        TeamMembersReportsComponent,
        CreateCandidateNewComponent,
        TalentpoolInsightsComponent,
        ReportDetailsComponent,
        ReportFiltersComponent,
        ReportOverviewTabComponent,
        ReportLocationTabComponent,
        ReportEducationTabComponent,
        ReportSkillsComponent,
        ReportIndustriesComponent,
        ReportTitlesComponent,
        ReportProfilesComponent,
        ReportDiversityComponent,
        ReportsComponent,
        ReportCompanyComponent,
        SaveSearchModalComponent,
        PersonSearchInsightsComponent,
        // CompanyHoverModalComponent,
        ShareTalentpoolsModalComponent,
        SharedTalentpoolsListingComponent,
        SourceHoverModalComponent,
        // PersonSearchSimilarSliderComponent,
        PersonSearchFilterComponent,
        CapitalizeFirstLetterPipe,
        // AddContactDetailsSliderComponent
        CompanypageAiComponent,
        TalentInsightsAiComponent,
        PersonSearchAiComponent,
        BulkRevealModalComponent,
        DocumentTabComponent,
        ActivityTabComponent,
        UnsubscribeComponent,
        AddEditExperienceModalComponent,
        EducationModalComponent,
        ExtendedChiplistComponent,
        SimilarCandidateFilterComponent,
        ExtendedSliderComponent,
        GenAiJdSearchComponent,
        IndianNumberFormatPipe,
        QuickSearchComponent,
        JdSearchComponent,
        ContinentSelectorComponent,
        AiModalScComponent,
        PlatformTourModalComponent,
        SaveSearchPersmissionModalComponent,
        TalentpoolRecommendedCandidateListComponent,
        WebbtreeTalentInsightsComponent,
        InsightsProfileSectionComponent,
        WebbtreeInsightsComponent,
        WebbtreeFreemiumBannerComponent,
        SevenDayFreeTrialFormComponent,
        WebbtreeFreemiumProfileComponent,
        TalentpoolReportSectionComponent,
        WebbtreeJdSearchFilterModalComponent,
        GenAiLoaderComponent,
        WebbtreeFooterComponent,
        SevenDayFreeTrialModalComponent,
        EuropeAccessModalComponent,
        EuropeAccessDocumentComponent,
        CreatePasswordComponent,
        NewsignupComponent,
        CompanyInsightsHistoryMdoalComponent,
        SettingsComponent,
        PlanComponent,
        TagManagementComponent,
        ProfilesComponent,
        CreditsComponent,
        TeamManagementComponent,
        EmailTemplatesComponent,
        EmailIntegrationsComponent,
        AtsIntegrationsComponent,
        // IntegrationComponent,
        SelfSignupComponent,
        WebbtreeCompanyListComponent,
        MultiselectSearchComponent,
        WebbtreeCompanyDetailsComponent,
        WebbtreeCompanySearchComponent,
        WebbtreeComapnylistFooterComponent,
        CompanyComparisonDetailsComponent,
        CompanyComparisonOverviewComponent,
        AddCompanyModalComponent,
        WebbtreeCompanyFiltersComponent,
        SimilarCompaniesComponent,
        CompanyComparisonSliderComponent,
        ComparisonSkeletonLoaderComponent,
        CompanylistSkeletonLoaderComponent,
        CompanyComparisonAiComponent,
        AiSourcingComponent,
        ProjectListComponent,
        ProjectDetailsComponent,
        JdDescriptionComponent,
        AiSourcingInsightsComponent,
        ProjectTalentInsightsComponent,
        AiSourcingProfilesComponent,
        AiSourcingReviewComponent,
        AiSourcingProfileCardComponent,
        AiSourcingLandingpageComponent,
        ExploringEvaluationCriteriaComponent,
        JdFilterComponent,
        EvaluationCriteriaComponent,
        AiSourcingArchiveComponent,
        InsightsSidebarComponent,
        AiSourcingShortlistComponent,
        AiSourcingActivityComponent,
        ArchiveCandidateModalComponent,
        AiSourcingProfileSkeletonComponent,
        AiSourcingInsightsAiComponent,
        EvaluationSliderComponent,
        TalentInsightsFreeTrialFormComponent,
        TalentInsightsFreeTrialModalComponent,
        TalentInsightsFreeTrialBannerComponent,
        BulkEmailCampaignComponent,
        AiResumeScreenerComponent,
        AiResumeFormComponent,
        UserprofileComponent,
        SkillsTaxonomyComponent,
        SkilltaxonomyLoaderComponent,
        MymodalComponent,
        MarketingModalComponent,
        SimilarityInsightsModalComponent,
        AutopilotPermissionComponent,
        ShareProjectComponent,
        CustomModalComponent,
        BlurbackdropComponent,
        JdinsightsModalComponent,
        AutopilotPermissionComponent,
        NlSearchComponent,
        BulkResumeUploadModelComponent,
        CsvFileUploadModelComponent,
        ResumeScreenComponent,
        CandidateListingComponent,
        CreateJobComponent,
        ScreeningCriteriaComponent,
        LandingPageComponent,
        JobDetailsComponent,
        SidebarScreenComponent,
        BulkUploadResumeModelComponent,
        InsightsJoblistComponent,

        HireTalentInsightsComponent,
                CampaignsLimitsComponent,

    ],
    bootstrap: [AppComponent],
    imports: [
        InfiniteScrollModule,
        BrowserModule,
        AppRoutingModule,
        NgbModule,
        FormsModule,
        MatTooltipModule,
        ReactiveFormsModule,
        AngularEditorModule,
        SideNavbarModule,
        BrowserAnimationsModule,
        AutoCompleteModule,
        MatAutocompleteModule,
        MatProgressBarModule,
        NgxIntlTelInputModule,
        SelectModule,
        EditorModule,
        MatRadioModule,
        MatChipsModule,
        ClipboardModule,
        MatIconModule,
        MatTableModule,
        MatBadgeModule,
        NgbCarouselModule,
        MatSortModule,
        MatFormFieldModule,
        MatSelectModule,
        MultiSelectModule,
        EmailCampaignModule,
        PersonSearchModule,
        OpenaiModule,
        NgxSliderModule,
        MatDatepickerModule,
        CarouselModule,
        YouTubePlayerModule,
        PdfViewerModule,
        UnifiedModule,
        MatListModule,
        DragDropModule,
        NewSettingsModule,
        MatListModule,
        RecaptchaModule,
        DragDropModule,
        FusionChartsModule,
        DefaultLocationModalComponent,
        CommonModule,
        DropdownToggleDirective,
        CustomInputComponent,
        HireSidebarComponent,
        ProjectListSkeletonComponent,


        ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingScreenInterceptor, multi: true },
        GoogleLoginService,
        DataService,
        DatePipe,
        NgbActiveModal,
        provideHttpClient(withInterceptorsFromDi()),

    ]
})
export class AppModule { }
